import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { salvaBlob } from '../../utils/documenti';
import Icona from '../cliente/Icone';
import { errore } from './comuni';

// Impostazioni → Moduli e contratti: i PDF da far firmare dal telefono (incarico, privacy, contratti). Se il PDF ha
// campi compilabili chiamati Nome, Cognome, Codice fiscale, Indirizzo, Data (o come gli importi) si riempiono da soli;
// in fondo si aggiunge sempre la pagina "Riepilogo e firma".

const TIPI = [['incarico', 'Incarico'], ['privacy', 'Privacy'], ['contratto', 'Contratto'], ['altro', 'Altro']];

const ModuliContratti = () => {
  const [moduli, setModuli] = useState(null);
  const [nuovo, setNuovo] = useState({ nome: '', tipo: 'incarico', importi: '' });
  const [file, setFile] = useState(null);
  const [attesa, setAttesa] = useState(false);
  const input = useRef(null);
  const carica = useCallback(() => axios.get(`${API}/moduli`, { params: { tutti: true } }).then((r) => setModuli(r.data)).catch(() => setModuli([])), []);
  useEffect(() => { carica(); }, [carica]);

  const aggiungi = async () => {
    setAttesa(true);
    const modulo = new FormData();
    modulo.append('file', file, file.name);
    modulo.append('nome', nuovo.nome.trim());
    modulo.append('tipo', nuovo.tipo);
    modulo.append('importi', JSON.stringify(nuovo.importi.split(',').map((x) => x.trim()).filter(Boolean).map((etichetta) => ({ etichetta }))));
    try {
      await axios.post(`${API}/moduli`, modulo);
      toast.success('Modulo caricato');
      setNuovo({ nome: '', tipo: 'incarico', importi: '' });
      setFile(null);
      carica();
    } catch (e) { toast.error(errore(e, 'Modulo non caricato')); } finally { setAttesa(false); }
  };
  const attiva = async (m, attivo) => {
    try { await axios.put(`${API}/moduli/${m.id}`, { attivo }); carica(); } catch (e) { toast.error(errore(e, 'Non riuscito')); }
  };
  const scarica = async (m) => {
    try {
      const r = await axios.get(`${API}/moduli/${m.id}/pdf`, { responseType: 'blob' });
      salvaBlob(r.data, m.nome_file || `${m.nome}.pdf`);
    } catch { toast.error('PDF non scaricato'); }
  };

  return (
    <div className="imp-griglia" data-testid="moduli-contratti">
      <section className="card">
        <div className="ttl"><div className="i"><Icona nome="piu" /></div><h2>Carica un modulo</h2></div>
        <div className="imp-campi">
          <label>Nome<input placeholder="es. Incarico di mediazione" value={nuovo.nome} onChange={(e) => setNuovo({ ...nuovo, nome: e.target.value })} /></label>
          <label>Tipo di modulo
            <select value={nuovo.tipo} onChange={(e) => setNuovo({ ...nuovo, tipo: e.target.value })}>
              {TIPI.map(([v, n]) => <option key={v} value={v}>{n}</option>)}
            </select>
          </label>
          <label>Importi, separati da virgola<input placeholder="es. Provvigione" value={nuovo.importi} onChange={(e) => setNuovo({ ...nuovo, importi: e.target.value })} /></label>
        </div>
        <input ref={input} type="file" accept="application/pdf" hidden onChange={(e) => { setFile(e.target.files?.[0] || null); e.target.value = ''; }} data-testid="pdf-modulo" />
        <div className="imp-azioni">
          <button type="button" className="btn sm" onClick={() => input.current?.click()}>{file ? file.name : 'Scegli il PDF'}</button>
          <button type="button" className="btn sm p" disabled={!file || nuovo.nome.trim().length < 3 || attesa} onClick={aggiungi}>{attesa ? 'Carico…' : 'Carica'}</button>
        </div>
        <p className="imp-nota" style={{ marginTop: '.8rem' }}>
          I dati del cliente entrano da soli nei campi compilabili del PDF chiamati Nome, Cognome, Codice fiscale, Indirizzo, Data e negli importi con lo stesso nome.
          In ogni caso in fondo c'è la pagina "Riepilogo e firma" con i dati, la firma, data, ora, IP e l'impronta del file.
        </p>
      </section>
      <section className="card">
        <div className="ttl"><div className="i"><Icona nome="documento" /></div><h2>Moduli {moduli ? <small>{moduli.length}</small> : null}</h2></div>
        {moduli && !moduli.length && <p className="vuoto">Nessun modulo ancora.</p>}
        <div className="imp-righe">
          {(moduli || []).map((m) => (
            <div key={m.id} className={m.attivo ? undefined : 'spento'} data-testid={`modulo-${m.id}`}>
              <b>{m.nome}</b>
              <span className="tag t-o">{(TIPI.find((t) => t[0] === m.tipo) || [0, m.tipo])[1]}</span>
              {!m.attivo && <span className="tag t-r">disattivato</span>}
              <span className="descr">
                {m.pagine} pagin{m.pagine === 1 ? 'a' : 'e'} · {m.campi_pdf?.length ? `campi: ${m.campi_pdf.join(', ')}` : 'senza campi compilabili'}
                {m.importi?.length ? ` · importi: ${m.importi.map((i) => i.etichetta).join(', ')}` : ''}
              </span>
              <div className="azioni">
                <button type="button" className="btn xs" onClick={() => scarica(m)}>PDF</button>
                <button type="button" className={`btn xs${m.attivo ? ' rosso-vuoto' : ''}`} onClick={() => attiva(m, !m.attivo)}>{m.attivo ? 'Disattiva' : 'Riattiva'}</button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ModuliContratti;
